import { c as _c } from "react/compiler-runtime";
import './supporter-identity.scss';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipTrigger } from '@sola/ark-core/molecules/tooltip/tooltip.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { InitialsAvatar } from '../../atoms/initials-avatar/initials-avatar.tsx';
import { useSupporterIdentity } from './supporter-identity.logic.ts';
export const SupporterIdentity: React.FC<{
  variant: 'full' | 'minimal' | 'dropdown';
  size?: 'sm' | 'md' | 'lg';
  notificationCount?: number;
  className?: string;
}> = t0 => {
  const $ = _c(39);
  const {
    variant,
    size,
    notificationCount,
    className
  } = t0;
  const {
    email,
    initials,
    name,
    supporterGlobalId
  } = useSupporterIdentity();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["priority"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  if (variant === "minimal") {
    let t2;
    if ($[1] !== className) {
      t2 = cn("SupporterIdentity", className);
      $[1] = className;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== initials || $[4] !== notificationCount || $[5] !== size) {
      t3 = <InitialsAvatar initials={initials} notificationCount={notificationCount} size={size} />;
      $[3] = initials;
      $[4] = notificationCount;
      $[5] = size;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
      t4 = <div className={t2}>{t3}</div>;
      $[7] = t2;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (variant === "dropdown") {
    let t2;
    if ($[10] !== className) {
      t2 = cn("SupporterIdentity SupporterIdentity--dropdown flex flex-row gap-snug-xl items-center", className);
      $[10] = className;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    let t3;
    if ($[12] !== initials || $[13] !== size) {
      t3 = <InitialsAvatar initials={initials} size={size} />;
      $[12] = initials;
      $[13] = size;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ArkIcon iconName="chevron-down" size="20" className="label-neutral-mild lg:hidden" />;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    let t5;
    if ($[16] !== t2 || $[17] !== t3) {
      t5 = <div className={t2}>{t3}{t4}</div>;
      $[16] = t2;
      $[17] = t3;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  let t2;
  if ($[19] !== className) {
    t2 = cn("SupporterIdentity SupporterIdentity--full grid gap-x-comfy-xs px-comfy-sm lg:px-comfy-xs", className);
    $[19] = className;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== initials || $[22] !== notificationCount) {
    t3 = <InitialsAvatar initials={initials} size="md" className="SupporterIdentity__avatar shrink-0" notificationCount={notificationCount} />;
    $[21] = initials;
    $[22] = notificationCount;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== name) {
    t4 = name && <span className="label-xl label-potent label-neutral-potent overflow-hidden m-0 text-wrap-nowrap text-ellipsis">{name}</span>;
    $[24] = name;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== email) {
    t5 = email && <span className="label-md label-moderate label-neutral-mild overflow-hidden text-wrap-nowrap text-ellipsis">{email}</span>;
    $[26] = email;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== t4 || $[29] !== t5) {
    t6 = <div className="SupporterIdentity__details flex flex-col overflow-hidden justify-center">{t4}{t5}</div>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== supporterGlobalId || $[32] !== t) {
    t7 = supporterGlobalId && <span className="SupporterIdentity__supporter-id label-md label-moderate label-neutral-mild overflow-hidden py-snug-xl text-wrap-nowrap text-ellipsis">{t("priority:nav.supporterId")}: {supporterGlobalId}{" "}<Tooltip><TooltipTrigger><button type="button" className="align-middle"><ArkIcon iconName="info-circle" /></button></TooltipTrigger><TooltipContent size="sm" align="end">{t("priority:nav.supporterTooltip")}</TooltipContent></Tooltip></span>;
    $[31] = supporterGlobalId;
    $[32] = t;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t2 || $[35] !== t3 || $[36] !== t6 || $[37] !== t7) {
    t8 = <div className={t2}>{t3}{t6}{t7}</div>;
    $[34] = t2;
    $[35] = t3;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  return t8;
};